import { ProblemJsonError } from "@pushback-and-chaos/client";

/**
 * WHEN A READ IS WORTH ASKING AGAIN (2026-09-24). A refusal for asking too
 * often (429), a server error (5xx) or a dropped connection says nothing about
 * the learner's data, so the page asks again after a pause rather than
 * drawing a desk without its papers or a coach who "could not be reached".
 * A 4xx that answers the question (not found, not yours, not ready) is final.
 */
const MAX_RETRIES = 3;

export function isTransient(error: unknown): boolean {
  if (error instanceof ProblemJsonError) return error.status === 429 || error.status >= 500;
  // fetch rejects with a TypeError when the connection itself fails.
  return error instanceof TypeError;
}

export function retryTransient(failureCount: number, error: unknown): boolean {
  return failureCount < MAX_RETRIES && isTransient(error);
}

/** One, two, then four seconds: long enough for a busy minute to turn over its first requests. */
export function retryDelay(attempt: number): number {
  return Math.min(1000 * 2 ** attempt, 8000);
}
